import React, { useCallback, useMemo, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  deleteRequest,
  getRequest,
  optimisticOptions,
  postRequest,
  queries,
} from "../../react-query";
import { useParams } from "react-router-dom";
import { reverseArray } from "../../utils";
import { LabelStudioUI } from "../../components/bound-box/LabelStudioUI";
import { DynamicLabel } from "../../types";
import successToast from "../../utils/successToast";

export const StreamingLabelling = () => {
  // Constants and State
  let size = 1;
  const [page, setPage] = useState<number>(1);
  const [dynamicLabels, setDynamicLabels] = useState<DynamicLabel[]>([]);

  const params = useParams();

  // Data Fetching
  const { data: cameraData = {}, isLoading: isCameraLoading }: any = useQuery(
    [queries.camera, page, size],
    () => getRequest(`/camera/${params.camera_id}`),
    {
      enabled: !!params.camera_id,
    }
  );
  const { data: camera } = cameraData;

  const {
    data: preEventFetchingData = [],
    isLoading,
    error,
  }: any = useQuery(
    [queries.preEvent, page, size],
    () =>
      getRequest(
        `/pre-event?labelled=false&signed=true&is_streaming=true&page=${page}&pageSize=${size}`
      ),
    {
      enabled: !!page,
    }
  );

  // Destructuring Data
  const { data: preEvents = [], pagination = {} } = preEventFetchingData;
  
  const totalPages = useMemo(
    () => Math.ceil(pagination?.totalCount / pagination?.pageSize),
    [pagination]
  );

  const { mutate: createEventMutate } = useMutation(
    postRequest,
    optimisticOptions(queries.preEvent)
  );

  const { mutate: createPreEventMutate } = useMutation(
    postRequest,
    optimisticOptions(queries.preEvent)
  );

  const { mutate: deletePreEventMutate } = useMutation(
    deleteRequest,
    optimisticOptions(queries.preEvent)
  );

  // Event Handlers
  const handleNextPage = useCallback(
    () => setPage((prevPage) => prevPage + 1),
    []
  );

  const handlePrevPage = useCallback(
    () => setPage((prevPage) => prevPage - 1),
    []
  );

  //submit
  const submit = (payload: any) => {
    page > 1 && handlePrevPage();
    console.log("annotation1", payload);
    try {
      createEventMutate({
        endPoint: "/event",
        payload: {
          annotations: payload,
          pre_event_capture_id: preEvents[0].id,
          status: "LABELLED",
        },
      });
    } catch (error) {
      console.error("Error uploading snapshot:", error);
    }
  };

  // useEffect(() => {
  //   if (eventResponse && eventResponse.id) {
  //     setAnnotations([]);
  //   }
  // }, [eventResponse]);

 

  const duplicate = async () => {
    try {
      page > 1 && handlePrevPage();

      let pre_event = preEvents[0];
      createPreEventMutate({
        endPoint: "/pre-event/duplicate",
        payload: {
          is_streaming: pre_event.is_streaming,
          video_link: pre_event.video_link,
          image_link: pre_event.image_link,
          labelled_captain_id: pre_event.labelled_captain_id,
          camera_detail_id: pre_event.camera_detail_id,
          segment_uri: pre_event.segment_uri,
        },
      });

      successToast('Duplicate successfully!')
    } catch (error) {
      console.error("Error uploading snapshot:", error);
    }
  };

  const deleteLabel = async (id:string) => {
    try {
      page > 1 && handlePrevPage();

      let pre_event = preEvents[0];
      deletePreEventMutate({
        endPoint: `/pre-event/${pre_event.id}`,
        payload: {
          is_streaming: pre_event.is_streaming,
          video_link: pre_event.video_link,
          image_link: pre_event.image_link,
          labelled_captain_id: pre_event.labelled_captain_id,
          camera_detail_id: pre_event.camera_detail_id,
          segment_uri: pre_event.segment_uri,
        },
      });

      successToast('Deleted successfully!')
    } catch (error) {
      console.error("Error uploading snapshot:", error);
    }
  };


  const currentEvent = useMemo(() => preEvents[0], [preEvents]);

  if (isCameraLoading || isLoading) {
    return <div />;
  }

  return (
    <div
      className="h-full flex flex-col justify-between"
      style={{ position: "relative" }}
    >
      {currentEvent ? (
        <LabelStudioUI
          taskId={currentEvent.id}
          instructionLink={currentEvent.instruction_link}
          imageLocation={currentEvent.image_link}
          handleNextPage={handleNextPage}
          handlePrevPage={handlePrevPage}
          duplicate={duplicate}
          deleteLabel={deleteLabel}
          submit={submit}
          page={page}
          pagination={pagination}
          categories={reverseArray(camera.sub_categories)}
          dynamicLabels={dynamicLabels}
        setDynamicLabels={setDynamicLabels}
        />
      ) : (
        <div className="w-full h-full grid place-content-center text-white">
          No image found!
        </div>
      )}
    </div>
  );
};
